import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-loading-row',
  templateUrl: './skeleton-loading-row.component.html',
})
export class SkeletonLoadingRowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
